<template>
  <div class="pick-up-setting">
    <div class="tuolele-main-box">
      <div class="self-table">
        <div class="pick-up-notice">
          <p>操作提示：</p>
          <div>
            1、常规接校：通过开关控制店铺常规时间内，是否接校；开关打开，表示需要接校；开关关闭，表示不需要接校
          </div>
          <div>
            2、假期接校：通过开关控制店铺假期时间内，是否接校；开关打开，表示需要接校；开关关闭，表示不需要接校
          </div>
        </div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>店铺</td>
                <td>常规接校</td>
                <td>假期接校</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in shopList" :key="item.id">
                <td>{{ item.name }}</td>
                <td>
                  <el-switch
                    v-model="item.switch.FORMAL_RECEIVE"
                    active-color="#4c84ff"
                    inactive-color="#eeeeee"
                    @change="changeStatus(item, 'FORMAL_RECEIVE')"
                  />
                </td>
                <td>
                  <el-switch
                    v-model="item.switch.HOLIDAY_RECEIVE"
                    active-color="#4c84ff"
                    inactive-color="#eeeeee"
                    @change="changeStatus(item, 'HOLIDAY_RECEIVE')"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PickUpSetting',
  components: {},
  data() {
    return {
      shopList: []
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getVasList()
  },
  methods: {
    async getVasList() {
      const ret = await this.$http.getVasList()
      if (ret.code == 200) {
        this.shopList = ret.data.shop_switch
        this.shopList.forEach(e => {
          for (const key in e.switch) {
            if (e.switch.hasOwnProperty(key)) {
              e.switch[key] = e.switch[key] == 1
            }
          }
        })
      }
    },
    async changeStatus(item, key) {
      const status = item.switch[key] ? 1 : 0
      const ret = this.$http.setVasSubmit({
        key,
        value: status,
        shop_id: item.id
      })
      if (ret.code == 200) {
        this.getVasList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pick-up-setting {
  line-height: 28px;
  margin-bottom: 20px;
  color: $color_black;
  .pick-up-notice {
    p {
      font-size: 16px;
    }
    div {
      font-size: 14px;
    }
  }
}
</style>
